const getMatchingQueryParams = (queryParamsList: string[], searchParams: URLSearchParams): Record<string, string> => {
  const paramObject: Record<string, string> = {}
  queryParamsList.forEach((param) => {
    if (searchParams.has(param)) {
      // get method for URLSearchParams decodes value by default
      const paramValue = searchParams.get(param)
      if (paramValue) {
        // add encoding back to value
        paramObject[param] = encodeURIComponent(paramValue)
      }
    }
  })
  return paramObject
}

export default getMatchingQueryParams
